// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"465":"62643012","527":"c19a93fa"}[chunkId] + ".chunk.js";
};